import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { ButtonDecorator } from '../../components/ButtonDecorator/ButtonDecorator';
import { Loader } from '../../components/Loader/Loader';
import { Shape2, Shape2Icon } from '../../components/Shape2/Shape2';
import { Bem } from '../../service/Bem/Bem';
import { BatchesList } from '../BatchesList/BatchesList';
import { TriState } from '../BatchesList/typings';
import { CanvasFooter } from '../CanvasFooter/CanvasFooter';
import { Order } from '../common/typings';
import { CreativeSizesSelector } from '../CreativeSizesSelector/CreativeSizesSelector';
import { RecentOrderSelector } from '../RecentOrderSelector/RecentOrderSelector';

import './CommonCreatives.css';
import * as keyset from './CommonCreatives.i18n';
import { CommonCreativesProps, FilterProps } from './typings';

const i18n = i18nFactory(keyset);
const BLOCK = 'common-creatives';

export class CommonCreatives extends React.PureComponent<CommonCreativesProps> {
    static Filter = React.memo(
        ({
            isFilterEnabled,
            applySizesFilter,
            creativeSizes,
            creativeSizesDataProvider,
            order,
            exportUrl,
            loadItems
        }: FilterProps & Pick<CommonCreativesProps, 'loadItems'>) => {
            const onOrderChange = (val: Order) => {
                loadItems(0, val, creativeSizes);
            };

            return (
                <div className={Bem.cls(BLOCK, 'filters')}>
                    <CreativeSizesSelector
                        enabled={isFilterEnabled}
                        cls={Bem.cls(BLOCK, 'filter')}
                        change={applySizesFilter}
                        value={creativeSizes}
                        dataProvider={creativeSizesDataProvider}
                    />
                    <RecentOrderSelector value={order} cls={Bem.cls(BLOCK, 'filter')} change={onOrderChange} />
                    <ButtonDecorator
                        cls={Bem.cls(BLOCK, 'export')}
                        theme={'normal'}
                        type={'link'}
                        target={'blank'}
                        size={'s'}
                        text={i18n('export-excel')}
                        url={exportUrl}
                    >
                        <Shape2 cls={Bem.cls(BLOCK, 'export-icon')} width={16} height={16} icon={Shape2Icon.export} />
                    </ButtonDecorator>
                </div>
            );
        }
    );

    componentDidMount(): void {
        this.props.loadItems(0, this.props.filter.order, this.props.filter.creativeSizes);
    }

    render() {
        const { collection } = this.props.batchesList;
        const submitEnabled =
            collection.batches.filter(item => [TriState.TRUE, TriState.INDETERMINATE].includes(item.selected)).length >
            0;

        return (
            <div className={Bem.cls(BLOCK)}>
                {this.props.isBusy && <Loader size={'s'} />}
                <CommonCreatives.Filter
                    {...this.props.filter}
                    applySizesFilter={this.props.applySizesFilter}
                    loadItems={this.props.loadItems}
                />
                <BatchesList
                    cls={Bem.cls(BLOCK, 'list')}
                    {...this.props.batchesList}
                    isBusy={this.props.isBusy}
                    showDeleteConfirm={this.props.showDeleteConfirm}
                    showCreativesSelector={this.props.showCreativesSelector}
                    toggleSizesSelection={this.props.toggleSizesSelection}
                    submitSizesSelection={this.props.submitSizesSelection}
                    hideCreativesSelector={this.props.hideCreativesSelector}
                    hideDeleteConfirm={this.props.hideDeleteConfirm}
                    delete={this.props.delete}
                    setSelection={this.props.setSelection}
                    saveName={this.props.saveName}
                    load={this.onLoad}
                    createBatch={this.props.createBatch}
                />
                <CanvasFooter
                    cls={Bem.cls(BLOCK, 'footer')}
                    submitEnabled={submitEnabled}
                    submitVisible={true}
                    submitLabel={i18n('add-creatives')}
                    cancelLabel={i18n('cancel-and-return')}
                    error={this.props.error}
                    hideError={this.props.hideError}
                    submit={this.props.submit}
                    cancel={this.props.cancel}
                />
            </div>
        );
    }

    private onLoad = (offset: number) => {
        this.props.loadItems(offset, this.props.filter.order, this.props.filter.creativeSizes);
    };
}
